import { Container, Text, Sprite, Graphics } from "pixi.js";
import { ISocialsThemeRendererProps } from "./ISocialsThemeRenderer";

export const renderTheme3 = ({
  container,
  destination,
  integrations,
  widget,
  icons,
  scaleFactor,
}: ISocialsThemeRendererProps) => {
  const options = widget.options;
  const itemsContainer = new Container();

  let currentX = 0;
  const gap = 32 * scaleFactor;

  integrations.forEach((data) => {
    const item = new Container();

    // Circle BG
    // Sizes from config: xs: 48, sm: 56, md: 64, lg: 72, xl: 80
    const rawCircleSize =
      options.fontSize === "xs"
        ? 48
        : options.fontSize === "sm"
          ? 56
          : options.fontSize === "md"
            ? 64
            : options.fontSize === "lg"
              ? 72
              : 80;
    const circleSize = rawCircleSize * scaleFactor;
    const radius = circleSize / 2;

    const bg = new Graphics();
    bg.circle(0, 0, radius).fill(data.color);
    item.addChild(bg);

    // Icon (White)
    const iconTexture = icons[data.platform];
    const iconSize = radius * 1; // 50% of circle roughly? Config says 0.5 * circleSize (which is radius)

    if (iconTexture) {
      const icon = new Sprite(iconTexture);
      icon.width = iconSize;
      icon.height = iconSize;
      icon.anchor.set(0.5);
      icon.tint = 0xffffff; // White icon
      item.addChild(icon);
    }

    // Text
    const textStyle = {
      fontFamily: options.fontFamily || "Roboto",
      fontSize:
        (options.fontSize === "xs"
          ? 14
          : options.fontSize === "sm"
            ? 16
            : options.fontSize === "md"
              ? 18
              : options.fontSize === "lg"
                ? 20
                : 22) * scaleFactor,
      fill: options.textColor,
      fontWeight: options.bold ? "bold" : "normal",
      fontStyle: options.italic ? "italic" : "normal",
      align: "center",
      letterSpacing: options.wordSpacing,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any;

    const displayName = data.user?.displayName || `@${data.platform}`;
    const text = new Text({ text: displayName, style: textStyle });

    text.anchor.set(0.5, 0);
    text.y = radius + 12 * scaleFactor;

    item.addChild(text);

    if (options.underline) {
      const underline = new Graphics();
      underline.moveTo(0, 0);
      underline.lineTo(text.width, 0);
      underline.stroke({ width: 2 * scaleFactor, color: options.textColor });
      underline.x = text.x - text.width / 2;
      underline.y = text.y + text.height;
      item.addChild(underline);
    }

    if (options.strike) {
      const strike = new Graphics();
      strike.moveTo(0, 0);
      strike.lineTo(text.width, 0);
      strike.stroke({ width: 2 * scaleFactor, color: options.textColor });
      strike.x = text.x - text.width / 2;
      strike.y = text.y + text.height / 2;
      item.addChild(strike);
    }

    // Initial position in row
    // item center is at 0,0 locally
    // left bound is -max(radius, text.width/2)
    const itemWidth = Math.max(circleSize, text.width);

    item.x = currentX + itemWidth / 2;
    itemsContainer.addChild(item);

    currentX += itemWidth + gap;
  });

  itemsContainer.x = (destination.width - itemsContainer.width) / 2;
  itemsContainer.y = (destination.height - itemsContainer.height) / 2;

  container.addChild(itemsContainer);
};
